import { Component, ChangeDetectionStrategy } from '@angular/core'
import { AutomationEventTypes, AutomationHandler, AutomationTypes } from '@tokeet-frontend/automations'
import { UntypedFormBuilder } from '@angular/forms'
import { Store } from '@ngrx/store'
import { AutomationWizardPanelBaseComponent } from '@tv3/containers/automations/automations-wizard/automation-wizard-panel.component'
import { CreateIncidentPayload, IncidentSeverity, IncidentStatus } from '@tokeet-frontend/incident'
import { AuthService } from '@tv3/services/auth.service'
import {
  guestDeviceNotificationMessages,
  userDeviceNotificationMessages,
} from '@tv3/containers/automations/automations-wizard/lock/messages'
import { Actions } from '@ngrx/effects'

@Component({
  selector: 'app-lock-automation-wizard',
  templateUrl: './lock-automation-wizard.component.html',
  styleUrls: ['./lock-automation-wizard.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class LockAutomationWizardComponent extends AutomationWizardPanelBaseComponent {
  type = AutomationTypes.Device

  lowBatteryIncident: CreateIncidentPayload = {
    title: `Lock battery low`,
    description: `Please replace the battery.`,
    reporter_id: this.auth.user.id,
    categories: ['Facilities'],
    status: IncidentStatus.Open,
    severity: IncidentSeverity.High,
  }

  deviceIssueIncident: CreateIncidentPayload = {
    title: `Lock issue`,
    description: `Please fix the lock.`,
    reporter_id: this.auth.user.id,
    categories: ['Facilities'],
    status: IncidentStatus.Open,
    severity: IncidentSeverity.High,
  }

  guestNotificationMessages = guestDeviceNotificationMessages
  userNotificationMessages = userDeviceNotificationMessages

  constructor(
    private auth: AuthService,
    protected fb: UntypedFormBuilder,
    protected actions: Actions,
    protected store: Store<any>
  ) {
    super(actions, store, fb)

    this.form.patchValue({ event: AutomationEventTypes.DeviceConnected })
  }

  protected readonly AutomationHandler = AutomationHandler
}
